import { Schedule } from '@key-telematics/fleet-api-client';
import { TranslateService } from '@ngx-translate/core';
import { MeasurementUnitsService } from 'app/services';

export const DAYS_OF_THE_WEEK = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
export const MONTHS_OF_THE_YEAR = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

export function getScheduleDescription(i18n: TranslateService, units: MeasurementUnitsService, schedule: Schedule): string {

    switch (schedule.scheduleType) {
        case 'once':
            return i18n.instant(`ADMIN.EDITORS.SCHEDULEDREPORT.SCHEDULE_TYPES_DESC.ONCE`, {
                date: units.format(schedule.startTime, 'date', 'long').format,
                time: units.format(schedule.startTime, 'time', 'short').format,
            });
        case 'hourly':
            if (schedule.every > 1) {
                return i18n.instant(`ADMIN.EDITORS.SCHEDULEDREPORT.SCHEDULE_TYPES_DESC.HOURLY_PLURAL`, {
                    every: schedule.every,
                });
            } else {
                return i18n.instant(`ADMIN.EDITORS.SCHEDULEDREPORT.SCHEDULE_TYPES_DESC.HOURLY`);
            }
        case 'daily':
            if (schedule.every > 1) {
                return i18n.instant(`ADMIN.EDITORS.SCHEDULEDREPORT.SCHEDULE_TYPES_DESC.DAILY_PLURAL`, {
                    every: schedule.every,
                    time: units.format(schedule.startTime, 'time', 'short').format,
                });
            } else {
                return i18n.instant(`ADMIN.EDITORS.SCHEDULEDREPORT.SCHEDULE_TYPES_DESC.DAILY`, {
                    time: units.format(schedule.startTime, 'time', 'short').format,
                });
            }
        case 'weekly':
            return i18n.instant(`ADMIN.EDITORS.SCHEDULEDREPORT.SCHEDULE_TYPES_DESC.WEEKLY`, {
                days: DAYS_OF_THE_WEEK.reduce((arr, day, index) => {
                    if (schedule.days.includes(index)) {
                        arr.push(i18n.instant(`SHARED.WEEK_DAYS.LONG.${day}`));
                    }
                    return arr;
                }, []).join(', '),
                time: units.format(schedule.startTime, 'time', 'short').format,
            });
        case 'monthly':
            return i18n.instant(`ADMIN.EDITORS.SCHEDULEDREPORT.SCHEDULE_TYPES_DESC.MONTHLY`, {
                day: schedule.days[0] || 1,
                months: MONTHS_OF_THE_YEAR.reduce((arr, month, index) => {
                    if (schedule.months.includes(index + 1)) {
                        arr.push(i18n.instant(`SHARED.MONTHS.LONG.${month}`));
                    }
                    return arr;
                }, []).join(', '),
                time: units.format(schedule.startTime, 'time', 'short').format,
            });

        default:
            break;
    }


}
